import { Form, Modal, Input } from 'antd';
import { useEffect } from 'react';

interface BanConfirmDialogProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isForbidden?: boolean;
}

const BanConfirmDialog = ({
  isOpen,
  onClose,
  title,
  onConfirm,
  isForbidden = true,
}: BanConfirmDialogProps) => {
  const [form] = Form.useForm<{ reason: string }>();

  const handleOk = (values: { reason: string }) => {
    onConfirm(values.reason);
  };

  useEffect(() => {
    form.resetFields();
  }, [isOpen, form]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={title}
      destroyOnClose
      okButtonProps={{
        type: 'primary',
        htmlType: 'submit',
        danger: isForbidden,
      }}
      modalRender={(modal) => (
        <Form form={form} onFinish={(values) => handleOk(values)}>
          {modal}
        </Form>
      )}
    >
      <Form.Item
        label="理由"
        name="reason"
        rules={[{ required: true, message: '请输入理由' }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
    </Modal>
  );
};

export default BanConfirmDialog;
